module.exports = __webpack_public_path__ + "e3b8a744e410daa743f93fd0ed3c44ef.png";